import { SxStyles } from 'types';

export const container = (backdropColor?: string): SxStyles => {
  return {
    width: 'min-content',
    height: 'min-content',
    margin: 0,

    // белая подложка под аватар в случае прозрачного фона картинки
    '&:before': {
      backgroundColor: backdropColor,
    },
  };
};

export const avatar = (fontSize: number, borderRadius?: string): SxStyles => {
  return {
    zIndex: 1,
    position: 'relative',

    fontSize,
    lineHeight: '20px',
    fontWeight: '800',
    letterSpacing: '10%',

    borderRadius: borderRadius ?? '50%',
  };
};
